import { Box, Stack, Text } from '@mantine/core';
import { IconCheck } from '@tabler/icons-react';
import { ReactNode } from 'react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

const NOTES = [
  'Joint assets will stay on both records until you re-assign them.',
  'All individual profiles and their financial data will remain unchanged.',
];

function Note({ children }: { children: ReactNode }) {
  return (
    <Box
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 10,
        padding: 16,
        borderRadius: 20,
        backgroundColor: 'var(--mantine-color-success-1)',
      }}
    >
      <IconCheck size={20} color="var(--mantine-color-success-9)" style={{ flexShrink: 0 }} />
      <Text size="sm" fw={FONT_WEIGHTS.semibold} c="success.9">
        {children}
      </Text>
    </Box>
  );
}

export default function DisbandFamilyNotes() {
  return (
    <Stack gap={8}>
      {NOTES.map(note => (
        <Note key={note}>{note}</Note>
      ))}
    </Stack>
  );
}
